import React,{useState} from 'react'
import {useNavigate} from 'react-router-dom'
import api from '../contexts/BaseUrl';
import './ForgotPassword.css'
import {Spinner} from 'react-activity'
import "react-activity/dist/Spinner.css";

export default function ForgotPassword(){

    const navigate = useNavigate();

    const [forgotPassword, setForgotPassword] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    const [email, setEmail] = useState('');

    const handleForgotPassword = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        await api.post(`accounts/forgot-password`,{
            email:email
        },{
            headers:{
                "Content-Type" : "application/json"
            }
        }).then(response => {
            setIsLoading(false);
            setEmail('');
            setForgotPassword(1);
        }).catch(err => {
            setIsLoading(false);
            setIsError(true);
        })
    }

    return(
        <div className='forgotPassword'>
            {forgotPassword === 0 ?
            <div id='container' style={isError ? {height: 320} : {}}>
                <form id='containerBox' onSubmit={handleForgotPassword}>
                    <div id='header'>Forgot Your Password?</div>
                    <div id='emailHeader'>Email:</div>
                    <input
                        id='inputBox'
                        type='email'
                        required
                        placeholder='Type your email...'
                        onChange={(e) => setEmail(e.target.value)}
                        value={email}
                    />
                                        {isError && <div id='errorMsg'>Failed to send login link! Try again later.</div>}
                    {isLoading ?
                <button id='loginButton'><Spinner size={12} color = "white" style={{display:"block", margin:'auto'}} /></button> :
                <button id='loginButton'>Send Login Link</button>   
                }
                    
                    <div id='login' onClick={() => navigate('/')} >Want to Login?</div>
                </form>
            </div>
            :
            <div id ='containerSuccess'>
                <div id='successDetails'>Password reset link has been sent to your email.<br /> Please check your email.</div>
                <div id='login' onClick={() => navigate('/')} >Want to Login?</div>
            </div>
            }
        </div>
    )
}